import { render, staticRenderFns } from "./OrderingCommentForm.vue?vue&type=template&id=1b8a20cc&lang=pug&"
import script from "./OrderingCommentForm.vue?vue&type=script&lang=js&"
export * from "./OrderingCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports